module.exports = __webpack_public_path__ + "media/handshake-message/handshake-message3-9c012e8c.png";